var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

FIGURE.heroDownArrow = function() {
	const downArrow = $(".down-arrow.pulse-image");
	const hideDownArrow = function (hide = true) {
		hide ? downArrow.addClass("hide-arrow") : downArrow.removeClass("hide-arrow")
	}
	downArrow.on("click", function() {
		hideDownArrow();
	});
	if (downArrow.length) {
		$(window).on("scroll", function() {
			hideDownArrow($(window).scrollTop() > 100);
		});
	}
}();